import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box';
import './Services.css'
import IconButton from '@mui/material/IconButton';
import KeyboardBackspaceTwoToneIcon from '@mui/icons-material/KeyboardBackspaceTwoTone';
import ArrowForwardTwoToneIcon from '@mui/icons-material/ArrowForwardTwoTone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button } from '@mui/material';
import { getService, getChildService, getPrice } from '../components/ApiService'
import Swal from 'sweetalert2';

const ServiceCatalogue = () => {
    const [service, setservice] = useState([])
    const [childService, setchildService] = useState([])
    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [ifClicked, setifClicked] = useState(false)
    const [showPrice, setshowPrice] = useState(false)
    const [selectedCarData, setSelectedCarData] = useState(null);
    const [page, setPage] = useState(1)
    const [size, setSize] = useState(150)
    const [activeServiceId, setActiveServiceId] = useState(null);
    const [priceList, setPriceList] = useState([])


    useEffect(() => {
        serviceList()

        // GET CAR DETAILS FROM LOCAL STORAGE
        const fetchCarDetails = async () => {
            const storedData = localStorage.getItem('storedCarDetails')

            if (storedData && storedData !== "undefined") {
                const parsedData = JSON.parse(storedData)
                //STORE THE DATA GETTING FROM BRAND, CAR NAME & VARIANT
                setSelectedCarData(parsedData)
            } else {
                localStorage.removeItem("storedCarDetails")
                setSelectedCarData(null)
            }
        }

        fetchCarDetails()
    }, [])


    const serviceList = () => {
        getService().then((res) => {
            setservice(res.data.services)
            console.log(res.data.services, "service response")
        })
    }

    const getServiceChild = (parentServiceId) => {
        setifClicked(true) //sets the service description list to show
        console.log(parentServiceId, "parent Service IDssss")
        setSelectedServiceId(parentServiceId); // sets the active service

        getChildService(parentServiceId).then((res) => {
            setchildService(res.data.services)
            console.log(res.data.services, "child service response")
        })
    }

    const revealPrice = async (childServiceID) => {
        if (!selectedCarData || !childServiceID) return;
        console.log(childServiceID, "Service ID ---")

        setActiveServiceId(childServiceID); // 👈 track which service is active

        // const data = carData || selectedCarData;
        setshowPrice(true)
        await getPrice(
            page,
            size,
            childServiceID,
            selectedCarData.brandID,
            selectedCarData.modelID,
            selectedCarData.fuelId).then((res) => {
                if (Array.isArray(res.data.servicePrices)) {
                    setPriceList((prev) => ({
                        ...prev,
                        [childServiceID]: res.data.servicePrices // 👈 store price per serviceId
                    }));
                    console.log(priceList, "PRICE LIST")
                } else {
                    setPriceList((prev) => ({
                        ...prev,
                        [childServiceID]: []
                    }));
                }
            }).catch(error => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.onmouseenter = Swal.stopTimer;
                        toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    title: "No Price Listed"
                });
                console.error("No Price Listed", error);

                setPriceList((prev) => ({
                    ...prev,
                    [childServiceID]: []
                }));
            })

    }
    return (
        <>
            <Box sx={{ width: '100%' }}>
                <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <div className='serviceNametag'>
                        {service.map((items) => (
                            <li className="nav-item childService me-2" role="presentation">
                                <button className={selectedServiceId === items.serviceId ? 'btn_active' : 'btn_secondary'} type="button" onClick={() => getServiceChild(items.serviceId)}>
                                    <img src={items.serviceImageUrl} className='img-fluid' alt='CarGenie Service' /> {items.serviceName}
                                </button>
                            </li>
                        ))}
                    </div>
                </ul>

                <div className="tab-content">
                    <div>
                        {ifClicked == true ?
                            <>
                                {
                                    childService.length == 0 ?
                                        <h3 style={{ textAlign: 'center', margin: '4rem 0', color: '#bbbaba', fontWeight: '700' }}>
                                            Currently we have no services to offer for this category..
                                        </h3>
                                        :
                                        <>
                                            {childService.map((item, index) => (
                                                <>
                                                    <div className='serviceDesc'>
                                                        <h3> {item.serviceName} </h3>
                                                        <div className='descCont'>
                                                            <div
                                                                className="descTools"
                                                                dangerouslySetInnerHTML={{ __html: item.serviceDescription }}
                                                            ></div>
                                                            <img src={item.serviceImageUrl} className='img-fluid descImg' alt='carGenie' />
                                                        </div>
                                                        <div className='btn_direction'>
                                                            {activeServiceId !== item.serviceId && (
                                                                <Button
                                                                    variant="contained"
                                                                    color='secondary'
                                                                    key={index}
                                                                    startIcon={<VisibilityIcon />}
                                                                    onClick={() => revealPrice(item.serviceId)}
                                                                    disabled={!selectedCarData}
                                                                >
                                                                    View Price
                                                                </Button>
                                                            )}

                                                            {/* SHOW PRICE */}
                                                            <div className='balanceCont'>
                                                                {activeServiceId === item.serviceId && (
                                                                    Array.isArray(priceList[item.serviceId]) && priceList[item.serviceId].length > 0 ? (
                                                                        priceList[item.serviceId].map((priceItem, index) => (
                                                                            <h3 key={index} style={{fontWeight: "700", color: "#1f1c20"}}> ₹ {priceItem.price}</h3>
                                                                        ))
                                                                    ) : (
                                                                        <h4 style={{ textAlign: 'center', color: '#999' }}>
                                                                            Price Unavailable
                                                                        </h4>
                                                                    )
                                                                )}
                                                            </div>
                                                        </div>

                                                    </div >
                                                </>
                                            ))}



                                        </>
                                }
                            </>
                            :
                            <div className='d-flex flex-column justify-content-center align-items-center mb-5'>
                                <h3 style={{ textAlign: 'center', margin: '4rem 0 30px', color: '#bbbaba', fontWeight: '700' }}>Please select a Service </h3>
                                <span style={{color: '#bbbaba', marginBottom: '30px'}}> - OR - </span>
                                <Button
                                    href="https://api.whatsapp.com/send?phone=7003900368"
                                    variant="contained"
                                    color="secondary"
                                    size="medium"
                                    className='roundedBox'
                                    startIcon={<WhatsAppIcon/>}
                                    navigate> 
                                    Connect Genie
                                </Button>
                            </div>
                        }
                    </div>
                </div>
            </Box >
        </>
    )
}

export default ServiceCatalogue